module.exports = __webpack_public_path__ + "static/media/weekend-evening-games.ba84ec7f.png";